import { html } from 'omni-ui';
import {
  Om2FormFieldBase,
  mergeClass,
  wrapWithLink,
  SHARED_FIELD,
} from './common/base.js';

/**
 * Render a fixed image
 * This is a layout field, not an input field.
 */
export class Om2FormFieldFixedImage extends Om2FormFieldBase {
  static metadata = {
    layout: true,
    config: {
      maxContents: 0,
      label: 'fixed image',
      summary: 'src',
      fields: {
        src: {
          title: 'Image',
          type: 'image',
          required: true,
        },
        width: {
          title: 'Image Width (px)',
          type: 'string',
          enum: [16, 24, 32, 48, 64, 96, 128, 192, 256, 384, 512, 'fullwidth'],
          default: 96,
        },
        ratio: {
          title: 'Aspect Ratio',
          tooltip:
            'The aspect ratio of an image is the ratio of its width to its height (width by height).',
          type: 'string',
          enum: [
            '1by1',
            '5by4',
            '4by3',
            '3by2',
            '5by3',
            '16by9',
            '2by1',
            '3by1',
            '4by1',
            '5by1',
            '6by1',
            '7by1',
            '8by1',
            '9by1',
            '10by1',
            '4by5',
            '3by4',
            '2by3',
            '3by5',
            '9by16',
            '1by2',
            '1by3',
            '1by4',
            '1by5',
            '1by6',
            '1by7',
            '1by8',
            '1by9',
            '1by10',
          ],
          default: '1by1',
          hasSearch: true,
        },
        rounded: {
          type: 'boolean',
          title: 'Rounded Image',
          default: true,
        },
        alt: {
          title: 'Alt text',
          tooltip:
            "Alt text is the written copy that appears in place of an image on a webpage if the image fails to load on a user's screen",
          type: 'string',
        },
        url: SHARED_FIELD,
        class: {
          title: 'CSS Class',
          tooltip:
            'This is a space separated list of css classes (typically from bulma/omni-ui)',
          type: 'string',
        },
      },
    },
  };

  render() {
    const { schema } = this;

    // Implement the image ratio with inline css rather than a bulma class as
    // bulma doesn't support all the ratios we need (e.g. 1by10).
    const [ratioWidth, ratioHeight] = (schema.ratio || '1by1').split('by');
    const figureStyle = `padding-top: ${100 * (ratioHeight / ratioWidth)}%;`;

    let divStyle = '';
    let classes = 'image is-1by1'; // We override the 1by1 ratio with padding-top
    if (schema.width === 'fullwidth') {
      classes += ' is-fullwidth';
    } else {
      divStyle = `width: ${schema.width}px`;
    }

    const innerHTML = html`<div style="${divStyle}">
      <figure
        class="${mergeClass(classes, schema.class)}"
        style="${figureStyle}"
      >
        <img
          class="${schema.rounded ? 'is-rounded' : ''}"
          src="${schema.src}"
          alt="${schema.alt ?? ''}"
        />
      </figure>
    </div>`;
    return wrapWithLink(schema.url, innerHTML);
  }
}

Om2FormFieldFixedImage.register('fixed-image');
